import React, {Component, Fragment, ReactNode} from 'react';
import {Product, ProductOptionCode, ProductSKU} from 'services/entities/products';
import {BookingProduct, DraftBooking} from 'services/entities/booking';
import {StaffIcon} from 'components/Icon';
import ToggleButton from 'components/forms/ToggleButton';
import CheckBoxField from 'components/forms/CheckBoxField';
import './StaffCategory.scss';
import ExpandableItem from '../components/ExpandableItem';

interface StaffCategoryProps {
  booking: DraftBooking|null;
  products: Product[]|null;
  onProductQuantityChanged:(sku: string, quantity: number)=>void;
  onProductOptionValueChanged:(sku: string, option: string, value: string|null)=>void;
}

export default class StaffCategory extends Component<StaffCategoryProps> {
  render() {
    const products = this.props.products;
    if(!products || products.length === 0) {
      return null;
    }
    const staffProduct = products.find(pr => pr.sku === ProductSKU.Staff);
    if(!staffProduct) {
      console.warn("Staff product not found");
      return null;
    }
    const quantities = [];
    for(let k = 1; k <= staffProduct.maxQuantity; k++) {
      quantities.push(k);
    }
    const booking: DraftBooking|null = this.props.booking;
    const bookingProduct = booking ? (booking!.products.find(pr => pr.sku === staffProduct.sku) || null) : null;
    const selectedQuantity = bookingProduct ? bookingProduct.quantity : 0;
    return <ExpandableItem icon={<StaffIcon/>} title={'Staff'} className={'staff'}
                     description={<p>Book up to {staffProduct.maxQuantity} additional staff to assist during the hours of your booking.</p>}>
      <ul className="quantity">
        <li><ToggleButton selected={selectedQuantity === 0}
                                 onChange={(selected) => selected ? this.props.onProductQuantityChanged(staffProduct.sku, 0) : {}}>None</ToggleButton></li>
        { quantities.map(quantity => <li key={quantity}>
          <ToggleButton selected={selectedQuantity === quantity}
                               onChange={(selected) => selected ? this.props.onProductQuantityChanged(staffProduct.sku, quantity) : {}}>{ quantity }</ToggleButton>
        </li>) }
      </ul>
      { this.renderHourOption(staffProduct, bookingProduct, ProductOptionCode.HoursBefore,
        <Fragment>+ 1 hour of staff assistance <b>before</b> booking begins</Fragment>) }
      { this.renderHourOption(staffProduct, bookingProduct, ProductOptionCode.HoursAfter,
        <Fragment>+ 1 hour of staff assistance <b>after</b> booking ends</Fragment>) }
    </ExpandableItem>;
  }

  renderHourOption(product: Product, bookingProduct: BookingProduct|null, optionCode: string, label: ReactNode) {
    const option = product.options.find(op => op.code === optionCode);
    const selected = bookingProduct && option ? !!bookingProduct.optionValues[option.code] : false;
    return <CheckBoxField name={optionCode} checked={selected} label={label}
                   onChange={checked => this.onStaffOptionChanged(checked, optionCode)} />
  }

  onStaffOptionChanged = (checked:boolean, optionCode: string) => {
    const products = this.props.products;
    const staffProduct = products ? products.find(pr => pr.sku === ProductSKU.Staff) : null;
    if(!staffProduct) {
      console.warn("Staff product not found");
      return;
    }
    const option = staffProduct.options.find(op => op.code === optionCode);
    if(!option) {
      console.warn("Staff option not found: " + option);
      return;
    }
    if(checked) {
      this.props.onProductOptionValueChanged(ProductSKU.Staff, optionCode, option.values[0].code);
    } else {
      this.props.onProductOptionValueChanged(ProductSKU.Staff, optionCode, null);
    }
  };
}